export interface IDashboardState {
    isPatchActive: boolean,
    isPoiActive: boolean,
    isZoneActive: boolean,
    isAtsActive: boolean,
}

export enum DashboardConstants {
    TOGGLE_PATCH = 'TOGGLE_PATCH',
    TOGGLE_ZONE = 'TOGGLE_ZONE',
    TOGGLE_POI = 'TOGGLE_POI',

    ACTIVE_ZONE = 'ACTIVE_ZONE',
    INACTIVE_ZONE = 'INACTIVE_ZONE',

    INACTIVE_PATCH = 'HIDE_PATCH',
    ACTIVE_PATCH = 'SHOW_PATCH',

    HIDE_POI = 'HIDE_POI',
    SHOW_POI = 'SHOW_POI',

    ACTIVE_ATS = 'ACTIVE_ATS',
    INACTIVE_ATS = 'INACTIVE_ATS',
}


const init: IDashboardState = {
    isPatchActive: false,
    isPoiActive: false,
    isZoneActive: false,
    isAtsActive: false,
};

export function DashboardReducer(state: IDashboardState = init, action: any): IDashboardState {
    switch (action.type) {
        case DashboardConstants.TOGGLE_PATCH:
            const isPatchEnabled = !state.isPatchActive;
            return {...state, isPatchActive: isPatchEnabled};
        case DashboardConstants.TOGGLE_ZONE:
            const isZonEnabled = !state.isZoneActive;
            return {...state, isZoneActive: isZonEnabled};

        case DashboardConstants.TOGGLE_POI:
            const isPoiEnabled = !state.isPoiActive;
            return {...state, isPoiActive: isPoiEnabled};

        case DashboardConstants.ACTIVE_PATCH:
            return {...state, isPatchActive : true};
        case DashboardConstants.INACTIVE_PATCH:
            return {...state, isPatchActive : false};

        case DashboardConstants.SHOW_POI:
            return {...state, isPoiActive : true};
        case DashboardConstants.HIDE_POI:
            return {...state, isPoiActive : false};

        case DashboardConstants.ACTIVE_ZONE:
            return {...state, isZoneActive : true};
        case DashboardConstants.INACTIVE_ZONE:
            return {...state, isZoneActive : false};

        case DashboardConstants.ACTIVE_ATS:
            return {...state, isAtsActive : true};
        case DashboardConstants.INACTIVE_ATS:
            return {...state, isAtsActive : false};

        default:
            return state;
    }
}

export  class DashboardAction {
    togglePatch = () => {
        return {type: DashboardConstants.TOGGLE_PATCH}
    };

    togglePoi = () => {
        return {type: DashboardConstants.TOGGLE_POI}
    };

    toggleZone = () => {
        return {type: DashboardConstants.TOGGLE_ZONE}
    };

    inActivePatch = () => {
        return {type: DashboardConstants.INACTIVE_PATCH}
    };

    activePatch = () => {
        return {type: DashboardConstants.ACTIVE_PATCH}
    };

    inActivePoi = () => {
        return {type: DashboardConstants.HIDE_POI}
    };

    activePoi = () => {
        return {type: DashboardConstants.SHOW_POI}
    };

    inActiveZone = () => {
        return {type: DashboardConstants.INACTIVE_ZONE}
    };

    activeZone = () => {
        return {type: DashboardConstants.ACTIVE_ZONE}
    };

    inActiveAts = () => {
        return {type: DashboardConstants.INACTIVE_ATS}
    };

    activeAts = () => {
        return {type: DashboardConstants.ACTIVE_ATS}
    };
}
